import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import Link from "next/link";

const Breadcrumbs = ({ currentPage }) => {
  return (
    <nav
      className="breadcrumbs text-sm width-full"
      aria-label="Fil d’Ariane"
      itemScope
      itemType="https://schema.org/BreadcrumbList">
      <ol
        className="flex gap-2"
        style={{ listStyle: "none", padding: 0, margin: 0 }}>
        <li
          itemProp="itemListElement"
          itemScope
          itemType="https://schema.org/ListItem">
          <Link href="/" itemProp="item">
            <span itemProp="name">Accueil</span>
          </Link>
          <meta itemProp="position" content="1" />
        </li>
        <li
          itemProp="itemListElement"
          itemScope
          itemType="https://schema.org/ListItem"
          aria-current="page">
          <FontAwesomeIcon icon={faAngleRight} className="w-4 h-4 mr-4" />
          <span itemProp="name">{currentPage}</span>
          <meta itemProp="position" content="2" />
        </li>
      </ol>
    </nav>
  );
};

Breadcrumbs.propTypes = {
  currentPage: PropTypes.string.isRequired,
};

export default Breadcrumbs;
